import { useEffect, useRef, useState } from 'react';
import { AppUser, OperatorRole } from '../../pm/types';
import { OPERATOR_ROLE_LABELS, OPERATOR_ROLE_ORDER } from '../../pm/constants';
import {
  revokeOperator,
  updateOperatorRole,
  updateOperatorTitle,
} from '../../pm/firebase';

interface Props {
  user: AppUser;
  disabled?: boolean;
}

const ManageOperatorMenu: React.FC<Props> = ({ user, disabled }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  async function changeRole(role: OperatorRole) {
    setOpen(false);
    await updateOperatorRole(user.uid, role);
  }

  async function changeTitle() {
    setOpen(false);
    const next = window.prompt('New title:', user.title || '');
    if (next === null) return;
    await updateOperatorTitle(user.uid, next);
  }

  async function revoke() {
    setOpen(false);
    if (!window.confirm(`Revoke operator access for ${user.email}?`)) return;
    await revokeOperator(user.uid);
  }

  if (disabled) {
    return <span className="pm-link-button pm-link-disabled">MANAGE</span>;
  }

  return (
    <span className="pm-manage-wrap" ref={wrapRef}>
      <button className="pm-link-button pm-manage-trigger" onClick={() => setOpen((v) => !v)}>MANAGE</button>
      {open ? (
        <div className="pm-manage-menu">
          <div className="pm-manage-section-title">Change role</div>
          {OPERATOR_ROLE_ORDER.map((r) => (
            <button
              key={r}
              className={r === user.operatorRole ? 'active' : ''}
              onClick={() => changeRole(r)}
            >
              {OPERATOR_ROLE_LABELS[r]}
            </button>
          ))}
          <div className="pm-manage-divider" />
          <button onClick={changeTitle}>Edit title…</button>
          <div className="pm-manage-divider" />
          <button className="pm-manage-danger" onClick={revoke}>Revoke operator access</button>
        </div>
      ) : null}
    </span>
  );
};

export default ManageOperatorMenu;
